import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { inject } from '@angular/core';

export const authenticationGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  if (inject(AuthenticationService).isUserLoggedIn()) {
    return true;
  }
  let url: string = state.url;

  // append dynamic query params
  if (route.queryParams) {
    const queryString = Object.entries(route.queryParams)
      .map((entry) => entry.join('='))
      .join('&');
    if (queryString) {
      url += `?${queryString}`;
    }
  }

  inject(AuthenticationService).saveReturnUrl(url);
  inject(Router).navigate(['login'], { queryParams: { returnUrl: url } });
  return false;
};
